import styled, {css} from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {TILE_PER_ROW_TABLET, TILE_PER_ROW_DESKTOP} from "../../constants/list"

const Item = styled.div`
  ${({theme}) => css`
    max-width: 100%;
    margin: 0 ${theme.spacing.one};
    ${minWidthMedia.tablet`
      max-width: calc((100% - (${theme.spacing.one} * 2 * ${TILE_PER_ROW_TABLET})) / ${TILE_PER_ROW_TABLET});
    `}
    ${minWidthMedia.desktop`
      max-width: calc((100% - (${theme.spacing.one} * 2 * ${TILE_PER_ROW_DESKTOP})) / ${TILE_PER_ROW_DESKTOP});
    `}
  `}
`

export default Item
